export const API = {
    'LANGUAGES': '/api/languages',
    'FRAMEWORKS': '/api/frameworks',
    'SNIPPETS': '/api/snippets',
    'SNIPPET': '/api/snippet',
    'COMMENTS': '/api/comments',
    'FAVORITE': '/api/favorite',
    'USER_FAVORITE': '/api/user-favorite',
    'USER_LOGIN': '/user/login',
    'USER_REGISTER': '/user/register',
};